<div class="image-pop">
  <button class="close" (click)="closePreview()">&#x2715;</button>
  <div class="overlay" (click)="closePreview()"></div>
  <video #videoplayer controlsList="nodownload nofullscreen">
    <source [src]="videoUrl" type="video/mp4">
  </video>
</div>
